import React, { useState } from "react";
import styled from "styled-components";
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from "react-icons/md";
import { GrPowerReset } from "react-icons/gr";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.15);
  padding-bottom: 1rem;
`;

const Label = styled.label`
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 1rem;
  padding-bottom: 0.5rem;
  color: var(--tertiary-font-color);
  font-family: Georgia, serif;
  cursor: pointer;
`;

const Container = styled.div`
  display: flex;
  flex-direction: row;
  gap: 5px;
  align-items: center;
`;

const InputLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.9rem;
  font-family: Verdana, sans-serif;
  color: var(--secondary-font-color);
  cursor: pointer;

  input {
    width: 3rem;
    height: 1.5rem;
    border: 1px solid var(--tertiary-font-color);
    border-radius: 3px;
    text-align: center;
  }
`;

export interface Props {
  label: string;
  isExpanded: boolean;
  onChange: (selectedValues: string) => void;
  name: string;
  options: {
    value: string;
    label: string;
  }[];
}

const Range: React.FC<Props> = ({
  label,
  onChange,
  name,
  options,
  isExpanded,
}) => {
  const [isOpen, setIsOpen] = useState(isExpanded);
  const [min, setMin] = useState(options[0].value || "0");
  const [max, setMax] = useState(options[1].value);

  const handleInputChange = (index: number, value: string) => {
    if (index === 0) {
      setMin(value);
      onChange(`${value}-${max}`);
    } else {
      setMax(value);
      onChange(`${min}-${value}`);
    }
  };

  const toggleDropdown = () => {
    setIsOpen((prev) => !prev);
  };

  const reset = () => {
    setMin(options[0].value || "0");
    setMax(options[1].value);
    onChange(`${options[0].value}-${options[1].value}`);
  };

  return (
    <Wrapper>
      <Label onClick={toggleDropdown}>
        {label}
        <GrPowerReset onClick={reset} style={{ cursor: "pointer" }} />
        {isOpen ? <MdKeyboardArrowUp /> : <MdKeyboardArrowDown />}
      </Label>

      {isOpen && (
        <Container>
          <InputLabel>
            {options[0].label}
            <input
              type="number"
              name={`${name}-min`}
              value={min}
              onChange={(e) => handleInputChange(0, e.target.value)}
            />
          </InputLabel>
          -
          <InputLabel>
            <input
              type="number"
              name={`${name}-max`}
              value={max}
              onChange={(e) => handleInputChange(1, e.target.value)}
            />
            {options[1].label}
          </InputLabel>
        </Container>
      )}
    </Wrapper>
  );
};

export default Range;
